import { AiFillCheckCircle, AiFillCloseCircle } from 'react-icons/ai';
import styled from 'styled-components';

export const policies = [
    {
        name: 'minLength',
        value: 12,
        message: 'Нууц үг 12-н тэмдэгтээс дээш байх ёстой',
    },
    {
        name: 'atLeastOneUppercase',
        value: true,
        message: 'Нууц үгэнд хамгийн багадаа нэг том үсгээс бүрдэх ёстой',
    },
    {
        name: 'atLeastOneLowercase',
        value: true,
        message: 'Нууц үгэнд хамгийн багадаа нэг жижиг үсгээс бүрдэх ёстой',
    },
    {
        name: 'atLeastOneNumber',
        value: true,
        message: 'Нууц үгэнд хамгийн багадаа нэг тоо байх ёстой',
    },
    {
        name: 'atLeastOneSpecialCharacter',
        value: true,
        message: 'Нууц үгэнд хамгийн багадаа нэг тусгай тэмдэгт байх ёстой',
    },
];
export const passwordPolicyCheck = (password) => {
    const errors = [];
    if (!password) {
        errors.push({
            error: true,
            key: 'passwordRequired',
            message: 'Нууц үг шаардлагатай',
        });
    }
    if (typeof password !== 'string') {
        errors.push({
            error: true,
            key: 'passwordType',
            message: 'Нууц үг үсгэн тэмдэгт байх ёстой',
        });
    }
    if (password.length < 12) {
        errors.push({
            error: true,
            key: 'minLength',
            message: 'Нууц үг 12-н тэмдэгтээс дээш байх ёстой',
        });
    }
    if (!RegExp(/[A-Z]/).test(password)) {
        errors.push({
            error: true,
            key: 'atLeastOneUppercase',
            message: 'Нууц үгэнд хамгийн багадаа нэг том үсгээс бүрдэх ёстой',
        });
    }
    if (!RegExp(/[a-z]/).test(password)) {
        errors.push({
            error: true,
            key: 'atLeastOneLowercase',
            message: 'Нууц үгэнд хамгийн багадаа нэг жижиг үсгээс бүрдэх ёстой',
        });
    }
    if (!RegExp(/[0-9]/).test(password)) {
        errors.push({
            error: true,
            key: 'atLeastOneNumber',
            message: 'Нууц үгэнд хамгийн багадаа нэг тоо байх ёстой',
        });
    }
    if (!RegExp(/[!@#$%^&*]/).test(password)) {
        errors.push({
            error: true,
            key: 'atLeastOneSpecialCharacter',
            message: 'Нууц үгэнд хамгийн багадаа нэг тусгай тэмдэгт байх ёстой',
        });
    }
    return {
        valid: errors.length === 0,
        errors,
    };
};

const PolicyContainer = styled.div`
    margin: 1rem 0;
    padding: 1rem;
    border-radius: 8px;
    background-color: #f8f9fa;
`;

const PolicyItem = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0.75rem 0;
    font-size: 0.9rem;
    color: #495057;

    .valid {
        color: #28a745;
        font-size: 1.1rem;
        min-width: 1.1rem;
    }

    .invalid {
        color: #dc3545;
        font-size: 1.1rem;
        min-width: 1.1rem;
    }
`;

export const renderPasswordPolicyCheck = (password) => {
    const { errors } = passwordPolicyCheck(password);
    return (
        <PolicyContainer>
            {policies.map((policy) => (
                <PolicyItem key={policy.name}>
                    {errors.find((error) => error.key === policy.name) ? <AiFillCloseCircle className="invalid" /> : <AiFillCheckCircle className="valid" />}
                    {policy.message}
                </PolicyItem>
            ))}
        </PolicyContainer>
    );
};
